import { useAppContext } from '../../store/AppContext';

const useNotification = () => {
  const [{ notifications }, stateDispatch] = useAppContext();

  const displayNotification = ({ message, color }) => {
    const timestamp = Date.now();

    stateDispatch({
      type: 'SET_POP_NOTIF',
      payload: notifications.concat([{
        id: timestamp,
        message,
        color,
      }]),
    });
  };

  return {
    displayNotification,
  };
};

export default useNotification;
